<template>
  <div>
    <v-card class="mt-0" width="500">
      <div class="d-flex">
        <v-img src="../../../../assets/logo.png" width="200" class="mx-auto" />
      </div>
      <div class="card-padding pb-0">
        <h4 class="text-h4 font-weight-bolder text-typo mb-2">
          Sign In Via Email Or Google
        </h4>
      </div>
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card
              outlined
              width="150"
              class="d-flex"
              ripple
              @click="provider = 'email'"
              :color="provider == 'email' ? 'grey' : ''"
            >
              <v-container>
                <v-btn icon width="100%" class="mx-auto" disabled>
                  <v-icon x-large>mdi mdi-email</v-icon>
                </v-btn>
                <h4 class="mt-2 text-center font-weight-normal">Email</h4>
              </v-container>
            </v-card>
          </v-col>
          <v-col>
            <v-card
              outlined
              width="150"
              class="d-flex"
              ripple
              @click="provider = 'google'"
              :color="provider == 'google' ? 'grey' : ''"
            >
              <v-container>
                <v-btn icon width="100%" class="mx-auto" disabled>
                  <v-icon x-large>mdi mdi-google</v-icon>
                </v-btn>
                <h4 class="mt-2 text-center font-weight-normal">Google</h4>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <form @submit.prevent="login" class="card-padding pb-4">
        <label class="text-xs text-typo font-weight-bolder ms-1" v-if="isEmail"
          >Email</label
        >
        <v-text-field
          v-if="isEmail"
          hide-details
          outlined
          light
          height="40"
          placeholder="Email"
          v-model="email"
          class="
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
        >
        </v-text-field>

        <label class="text-xs text-typo font-weight-bolder ms-1" v-if="isEmail"
          >Password</label
        >
        <v-text-field
          hide-details
          v-if="isEmail"
          v-model="password"
          outlined
          type="password"
          light
          height="40"
          placeholder="Password"
          class="
            font-size-input
            border border-radius-md
            placeholder-lighter
            text-color-light
            mb-4
            mt-2
          "
        >
        </v-text-field>

        <v-btn
          elevation="0"
          type="submit"
          :ripple="false"
          height="43"
          class="
            font-weight-bold
            text-uppercase
            btn-primary
            py-2
            px-6
            me-2
            mt-7
            mb-2
            w-100
          "
          color="black"
          small
        >
          {{ isEmail ? "Login" : "Login With Google" }}
        </v-btn>

        <div v-if="isEmail" class="text-center mt-2">
          <a 
            href="#" 
            class="text-caption text-error text-primary"
            @click.prevent="showResetDialog = true"
          >
            Forgot Password?
          </a>
        </div>
      </form>

      <reset-password v-model="showResetDialog" />
    </v-card>
  </div>
</template>
<script>
import fb from "../../../../plugins/firebase";
const auth = fb.auth;
const GoogleAuthProvider = fb.GoogleAuthProvider;
import { browserPopupRedirectResolver, signInWithPopup } from "firebase/auth";
import ResetPassword from "./ResetPassword.vue";

export default {
  name: "login",
  components: {
    ResetPassword
  },
  data() {
    return {
      checkbox: false,
      email: "",
      password: "",
      provider: "email",
      showResetDialog: false
    };
  },
  computed: {
    isEmail() {
      return this.provider === "email";
    },
  },
  methods: {
    login() {
      if (this.provider === "email") {
        this.loginWithEmail();
      }
      if (this.provider === "google") {
        this.loginWithGoogle();
      }
    },
    loginWithEmail() {
      if (this.email == "" || this.password == "") {
        alert("Please enter email and password");
        return;
      }
      this.$store.dispatch("loginUser", {
        email: this.email,
        password: this.password,
      }).then(() => {
        if (this.$store.state.auth && this.$store.state.auth.uid) {
          this.$router.push("/locations");
        }
      }).catch(error => {
        console.error("Error logging in:", error);
      });
    },
    async loginWithGoogle() {
      const provider = new GoogleAuthProvider();
      try {
        const result = await signInWithPopup(
          auth,
          provider,
          browserPopupRedirectResolver
        );
        const user = {
          email: result.user.email,
          uid: result.user.uid,
        };
        console.log(result.user);
        await this.$store.dispatch("loginUserWithGoogle", { ...user, ...result.user });
        if (this.$store.state.auth && this.$store.state.auth.uid) {
          this.$router.push("/locations");
        }
      } catch (error) {
        console.error("Error logging in with Google:", error);
      }
    },
  },
  created() {
    //this.$store.dispatch("logout");
  },
};
</script>
